<script setup lang="ts">

const props = defineProps<{
  property: any,
  apiData: any,
  style: any
}>()

const title = props.property.title;

const propertyKeys = computed(() => {
  return props.property.name.split('.');
})

const apiDataValue = computed(() => {
  let result = props.apiData;

  if(!result) return '-'

  for(let i = 0; i < propertyKeys.value.length; i++){
    
    result = result[propertyKeys.value[i]];
    // console.log(result);
    // console.log(propertyKeys.value[i]);
  }

  return result;
})


</script>
<template>
  <div class="basic-value-card common-card" :style="{background: props.style.background}">
    <div class="title">
      {{ props.property.title }}
    </div>
    <div class="content">
      <!-- {{ commonUtils.isAllStrDataEmpty(apiDataValue) }} -->
        {{ commonUtils.unitFormatter(apiDataValue, props.property.unit, props.property.name === 'prodRevenue' ? 0 : 1 ).value }}
      <span class="unit">{{ commonUtils.unitFormatter(apiDataValue, props.property.unit, props.property.name === 'prodRevenue' ? 0 : 1 ).unit }}</span>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use "@/assets/styles/design-toc/basic-value-card.scss";
@use "@/assets/styles/design-toc/define.scss";
@use "@/assets/styles/design-toc/common-card.scss";
</style>